import {
	Container,
	ContainerPadding,
	Text,
	TokenTextAppearance,
	TextAlignment,
} from '@volkswagen-onehub/components-core';
import React from 'react';

export const VWBookAgotado: React.FC = () => {
	return (
		<Container
			padding={{
				right: ContainerPadding.dynamic0100,
				bottom: ContainerPadding.dynamic0100,
				left: ContainerPadding.dynamic0100,
			}}
			horizontalAlign={'center'}
			wrap={'always'}
		>
			<Container wrap={'always'}>
				<Text appearance={TokenTextAppearance.headline300} textAlign={TextAlignment.center}>
					¡Lo sentimos!
				</Text>
				<Text appearance={TokenTextAppearance.headline300} textAlign={TextAlignment.center}>
					{'El Libro de diseño de Volkswagen\u0020'}
					<Text bold>se ha agotado...</Text>
				</Text>

				<Container
					wrap={'always'}
					padding={{
						top: ContainerPadding.dynamic0200,
						bottom: ContainerPadding.dynamic0100,
					}}
					verticalAlign={'center'}
					horizontalAlign={'center'}
				>
					<Text appearance={TokenTextAppearance.copy200} textAlign={TextAlignment.center}>
						Ya se ha agotado la edición limitada del Libro de diseño de Volkswagen que estábamos regalando.
					</Text>
					<Text appearance={TokenTextAppearance.copy200} textAlign={TextAlignment.center}>
						Pero sigue pendiente, porque pronto habrá más novedades en el club.
					</Text>
				</Container>
			</Container>
		</Container>
	);
};
